import type { Column } from "@shared/types/data-table"
import type { Invoice } from "@shared/types/invoices"
import type { ColumnManagementConfig } from "@shared/lib/tables/utils/column-management"
import { 
  createTextColumn,
  createStatusColumn,
  createCurrencyColumn,
  createDateColumn
} from "./column-factories"

export const INVOICE_COLUMNS: Record<string, Column<Invoice>> = {
  total: createCurrencyColumn<Invoice>("total", "Total"),
  frequency: createTextColumn<Invoice>("frequency", "Frequency", 120),
  invoiceNumber: createTextColumn<Invoice>("invoiceNumber", "Invoice number", 150, "font-mono"),
  customerName: createTextColumn<Invoice>("customerName", "Customer name", 180, "font-semibold"),
  customerEmail: createTextColumn<Invoice>("customerEmail", "Customer email", 200),
  due: createDateColumn<Invoice>("due", "Due"),
  created: createDateColumn<Invoice>("created", "Created"),
  finalizationDate: createDateColumn<Invoice>("finalizationDate", "Finalization date"),
  status: createStatusColumn<Invoice>("invoice"),
  currency: createTextColumn<Invoice>("currency", "Currency", 80),
  description: createTextColumn<Invoice>("description", "Description", 200),
}

export function getInvoiceColumns(): Column<Invoice>[] {
  return [
    INVOICE_COLUMNS.total,
    INVOICE_COLUMNS.status,
    INVOICE_COLUMNS.frequency,
    INVOICE_COLUMNS.invoiceNumber,
    INVOICE_COLUMNS.customerName,
    INVOICE_COLUMNS.customerEmail,
    INVOICE_COLUMNS.due,
    INVOICE_COLUMNS.created,
    INVOICE_COLUMNS.finalizationDate,
  ]
}

export function getInvoiceColumnConfig(): ColumnManagementConfig[] {
  const allColumns = Object.entries(INVOICE_COLUMNS).map(([key, column]) => ({
    id: key,
    label: typeof column.header === 'string' ? column.header : key,
    visible: [
      'total',
      'status',
      'frequency', 
      'invoiceNumber',
      'customerName',
      'customerEmail',
      'due',
      'created',
      'finalizationDate'
    ].includes(key),
  }))

  return allColumns
}